import { render, staticRenderFns } from "./commonLabelDialog.vue?vue&type=template&id=2e4f49aa&scoped=true"
import script from "./commonLabelDialog.vue?vue&type=script&lang=js"
export * from "./commonLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./commonLabelDialog.vue?vue&type=style&index=0&id=2e4f49aa&prod&scoped=true&lang=css"
import style1 from "./commonLabelDialog.vue?vue&type=style&index=1&id=2e4f49aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4f49aa",
  null
  
)

export default component.exports